import { initializeApp } from "firebase/app";
import { getStorage, ref as storageRef, getDownloadURL } from "firebase/storage";
import ExcelJS from "exceljs";

import { convertExcelToPdfThunk } from '../../../../actions/excelActions';
import { getCellPositionEducation, getCellPositionTenet, getCellPositionType, getCellQuality, getCellPositionZone, getIdTypeDocument } from '../GetStrings/cellUtils';


// Función auxiliar para exportar el workbook
const exportWorkbookAndConvert = async (workbook, dispatch, filename) => {
    try {
        // 1. Convertir el workbook a Blob Excel
        const buffer = await workbook.xlsx.writeBuffer();
        const blob = new Blob([buffer], {
            type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        });

        // 2. Enviar el blob al thunk
        dispatch(convertExcelToPdfThunk({ excelFile: blob, filename }));

    } catch (error) {
        console.error("Error al preparar el archivo Excel:", error);
    }
};

export const fetchAndFillExcelQuestions = async (visit, setLoading, dispatch, step, urlPicture) => {
    const firebaseConfig = {
        apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
        authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
        databaseURL: process.env.REACT_APP_FIREBASE_DATABASE_URL,
        projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
        storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
        messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
        appId: process.env.REACT_APP_FIREBASE_APP_ID,
    };


    // Initialize Firebase
    const app = initializeApp(firebaseConfig);

    setLoading(true); // Show progress circle
    try {
        const storage = getStorage(app);
        const fileRef = storageRef(storage, "files/Visita_Preguntas.xlsx");
        const url = await getDownloadURL(fileRef);
        const response = await fetch(url);
        const arrayBuffer = await response.arrayBuffer();

        // Leer el archivo Excel con exceljs
        const workbook = new ExcelJS.Workbook();
        await workbook.xlsx.load(arrayBuffer);

        // Acceder a la hoja específica
        const worksheet = workbook.getWorksheet("Anexo 1 B");
        if (!worksheet) {
            throw new Error("La hoja 'Visita' no existe en el archivo Excel.");
        }

        // Define a mapping of cell positions to data
        const cellDataMapping = {
            "T5": visit.city || "N/A",
            "X5": visit.dateInit ? visit.dateInit.substring(6, 10) : "N/A",
            "Z5": visit.dateInit ? visit.dateInit.substring(3, 5) : "N/A",
            "AB5": visit.dateInit ? visit.dateInit.substring(0, 2) : "N/A",
            "AD5": visit.dateInit ? visit.dateInit.substring(11, 16) : "N/A",
            "F8": visit.basicData.name || "N/A",
            "AA8": visit.basicData.documentNumber || "N/A",

            "M10": visit.concept.academicEvidence === "SI" ? "X" : "",
            "O10": visit.concept.academicEvidence === "NO" ? "X" : "",
            "W10": visit.concept.employmentEvidence === "SI" ? "X" : "",
            "Y10": visit.concept.employmentEvidence === "NO" ? "X" : "",

        };

        // Fill the cells using the mapping
        Object.entries(cellDataMapping).forEach(([cell, value]) => {
            worksheet.getCell(cell).value = value;
        });

        // Load the image of company logo
        const logoResponse = await fetch(urlPicture);
        const logoBuffer = await logoResponse.arrayBuffer();

        // Add the company logo image to the workbook
        const logoImageId = workbook.addImage({
            buffer: logoBuffer,
            extension: "png",
        });

        // Position the company logo image in the workbook
        worksheet.addImage(logoImageId, {
            tl: { col: 2, row: 1 },
            ext: { width: 130, height: 55 },
        });

        // For each image, fetch and add to the worksheet
        for (let i = 0; i < visit.specificQuestions.listSpecificQuestions.length; i++) {
            const cell = getQuestionsPosition(i);
            worksheet.getCell(`B${cell}`).value = visit.specificQuestions.listSpecificQuestions[i].question || "N/A";
            worksheet.getCell(`B${cell + 2}`).value = visit.specificQuestions.listSpecificQuestions[i].answer || "N/A";
        }


        // Save the workbook to a file
        if (step === "excel") {
            const buffer = await workbook.xlsx.writeBuffer();
            const blob = new Blob([buffer], {
                type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
            });
            const link = document.createElement("a");
            link.href = URL.createObjectURL(blob);
            link.download = ("Preguntas Visita " + visit.basicData.name + " " + visit.dateInit + ".xlsx").replace(/[/\\?%*:|"<>]/g, '-');
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
        } else {
            exportWorkbookAndConvert(workbook, dispatch, `Preguntas ${visit.basicData.name} ${visit.dateInit}`);
        }
    } catch (error) {
        console.error("Error al procesar el archivo Excel:", error);
    }
};

export const fecthhAndFillExcelImages = async (visit, setLoading, dispatch, step, urlPicture) => {
    const firebaseConfig = {
        apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
        authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
        databaseURL: process.env.REACT_APP_FIREBASE_DATABASE_URL,
        projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
        storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
        messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
        appId: process.env.REACT_APP_FIREBASE_APP_ID,
    };


    // Initialize Firebase
    const app = initializeApp(firebaseConfig);

    setLoading(true); // Show progress circle
    try {
        const storage = getStorage(app);
        const fileRef = storageRef(storage, "files/Visita_Imagenes.xlsx");
        const url = await getDownloadURL(fileRef);
        const response = await fetch(url);
        const arrayBuffer = await response.arrayBuffer();

        // Leer el archivo Excel con exceljs
        const workbook = new ExcelJS.Workbook();
        await workbook.xlsx.load(arrayBuffer);

        // Acceder a la hoja específica
        const worksheet = workbook.getWorksheet("Anexo 1 B");
        if (!worksheet) {
            throw new Error("La hoja 'Visita' no existe en el archivo Excel.");
        }

        // Define a mapping of cell positions to data
        const cellDataMapping = {
            "T5": visit.city || "N/A",
            "T83": visit.city || "N/A",
            "X5": visit.dateInit ? visit.dateInit.substring(6, 10) : "N/A",
            "X83": visit.dateInit ? visit.dateInit.substring(6, 10) : "N/A",
            "Z5": visit.dateInit ? visit.dateInit.substring(3, 5) : "N/A",
            "Z83": visit.dateInit ? visit.dateInit.substring(3, 5) : "N/A",
            "AB5": visit.dateInit ? visit.dateInit.substring(0, 2) : "N/A",
            "AB83": visit.dateInit ? visit.dateInit.substring(0, 2) : "N/A",
            "AD5": visit.dateInit ? visit.dateInit.substring(11, 16) : "N/A",
            "AD83": visit.dateInit ? visit.dateInit.substring(11, 16) : "N/A",
            "F8": visit.basicData.name || "N/A",
            "F86": visit.basicData.name || "N/A",
            "AA8": visit.basicData.documentNumber || "N/A",
            "AA86": visit.basicData.documentNumber || "N/A",

            "M10": visit.concept.academicEvidence === "SI" ? "X" : "",
            "M88": visit.concept.academicEvidence === "SI" ? "X" : "",
            "O10": visit.concept.academicEvidence === "NO" ? "X" : "",
            "O88": visit.concept.academicEvidence === "NO" ? "X" : "",
            "W10": visit.concept.employmentEvidence === "SI" ? "X" : "",
            "W88": visit.concept.employmentEvidence === "SI" ? "X" : "",
            "Y10": visit.concept.employmentEvidence === "NO" ? "X" : "",
            "Y88": visit.concept.employmentEvidence === "NO" ? "X" : "",

        };

        // Fill the cells using the mapping
        Object.entries(cellDataMapping).forEach(([cell, value]) => {
            worksheet.getCell(cell).value = value;
        });

        // Load the image of company logo
        const logoResponse = await fetch(urlPicture);
        const logoBuffer = await logoResponse.arrayBuffer();

        // Add the company logo image to the workbook
        const logoImageId = workbook.addImage({
            buffer: logoBuffer,
            extension: "png",
        });

        // Position the company logo image in the workbook
        worksheet.addImage(logoImageId, {
            tl: { col: 2, row: 1 },
            ext: { width: 130, height: 55 },
        });

        // For each image, fetch and add to the worksheet
        for (let i = 0; i < visit.listImages.length; i++) {
            const imageUrl = visit.listImages[i].urlImage;

            // Cargar la imagen
            const imageResponse = await fetch(imageUrl);
            const imageBuffer = await imageResponse.arrayBuffer();

            // Agregar la imagen al workbook
            const imageId = workbook.addImage({
                buffer: imageBuffer,
                extension: "jpg",
            });

            // Obtener posición dinámica
            const { col, row } = getImagePosition(i);

            worksheet.addImage(imageId, {
                tl: { col, row },
                ext: { width: 350, height: 580 },
            });
        }
        worksheet.getRow(77).addPageBreak();
        worksheet.getRow(155).addPageBreak();

        // Clear unused image slots
        if (visit.listImages.length <= 6) {
            for (let i = 78; i <= worksheet.rowCount; i++) {
                worksheet.getRow(i).values = [];
            }
        } else {
            // Position the company logo image in the workbook
            worksheet.addImage(logoImageId, {
                tl: { col: 2, row: 79 },
                ext: { width: 130, height: 55 },
            });
        }

        // Save the workbook to a file
        if (step === "excel") {
            const buffer = await workbook.xlsx.writeBuffer();
            const blob = new Blob([buffer], {
                type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
            });
            const link = document.createElement("a");
            link.href = URL.createObjectURL(blob);
            link.download = ("Imagenes Visita " + visit.basicData.name + " " + visit.dateInit + ".xlsx").replace(/[/\\?%*:|"<>]/g, '-');
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
        } else {
            exportWorkbookAndConvert(workbook, dispatch, `Imagenes ${visit.basicData.name} ${visit.dateInit}`);
        }
    } catch (error) {
        console.error("Error al procesar el archivo Excel:", error);
    }
};

function getImagePosition(index) {
    const cols = [1.9, 11.9, 21.9]; 
    const rowBase = index < 6 ? 14 : 92;
    const rowStep = 32;

    const col = cols[index % 3];
    const row = rowBase + Math.floor(index % 6 / 3) * rowStep;

    return { col, row };
}

function getQuestionsPosition(index) {
    const rowBase = 14;
    const rowStep = 6;

    const row = rowBase + index * rowStep;

    return row;
}

// Función principal para llenar el Excel
export const fetchAndFillExcel = async (visit, setLoading, dispatch, text, step, urlPicture) => {

    const firebaseConfig = {
        apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
        authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
        databaseURL: process.env.REACT_APP_FIREBASE_DATABASE_URL,
        projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
        storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
        messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
        appId: process.env.REACT_APP_FIREBASE_APP_ID,
    };


    // Initialize Firebase
    const app = initializeApp(firebaseConfig);

    setLoading(true); // Show progress circle
    try {
        const storage = getStorage(app);
        const fileRef = storageRef(storage, "files/VISITA_DOMICILIRIA_GC360.xlsx");
        const url = await getDownloadURL(fileRef);
        const response = await fetch(url);
        const arrayBuffer = await response.arrayBuffer();
        const cellPath = getCellPositionEducation(visit.basicData.educationLevel);
        let rowFinal = 0;

        // Leer el archivo Excel con exceljs
        const workbook = new ExcelJS.Workbook();
        await workbook.xlsx.load(arrayBuffer);

        // Acceder a la hoja específica
        const worksheet = workbook.getWorksheet("Visita");
        if (!worksheet) {
            throw new Error("La hoja 'Visita' no existe en el archivo Excel.");
        }

        // Define a mapping of cell positions to data
        const cellDataMapping = {
            "T5": visit.city || "N/A",
            "W5": visit.dateInit ? visit.dateInit.substring(6, 10) : "N/A",
            "AB5": visit.dateInit ? visit.dateInit.substring(3, 5) : "N/A",
            "AE5": visit.dateInit ? visit.dateInit.substring(0, 2) : "N/A",
            "AG5": visit.dateInit ? visit.dateInit.substring(11, 16) : "N/A",
            "H7": visit.basicData.companyName || "N/A",
            "H8": visit.basicData.name || "N/A",
            "AD8": visit.basicData.load || "N/A",
            "H9": visit.basicData.documentNumber || "N/A",
            "S9": visit.basicData.documentExpeditionLocation || "N/A",
            "AE9": visit.basicData.documentExpeditionDate || "N/A",
            "H10": visit.basicData.placeOfBirth || "N/A",
            "Z10": visit.basicData.dateOfBirth || "N/A",
            "AG10": visit.basicData.age + " Años" || "N/A",
            "H11": visit.basicData.civilStatus || "N/A",
            "Z11": visit.basicData.howLongMarried || "N/A",
            "H12": visit.basicData.address || "N/A",
            "U12": visit.basicData.neighborhood || "N/A",
            "AC12": visit.basicData.stratum || "N/A",
            "AF12": visit.basicData.phoneNumber || "N/A",
            [getCellPositionEducation(visit.basicData.educationLevel)]: "X",

            // family origin table
            "A18": "2.1 FAMILIA DE ORIGEN - Lugar de Procedencia: " + visit.familyInfo.originPlace || "N/A",

            // family nucleus
            // family other table 

            // house description
            [getCellPositionTenet(visit.descriptionHouse.tenet)]: "X",
            [getCellPositionType(visit.descriptionHouse.typeHouse)]: "X",
            [getCellQuality(visit.descriptionHouse.qualityHouse)]: "X",
            "N66": visit.descriptionHouse.otherQuality || "N/A",

            //distribution house
            "W62": visit.descriptionHouse.distribution.dinnerRoom === true ? "X" : "",
            "W63": visit.descriptionHouse.distribution.livingRoom === true ? "X" : "",
            "W64": visit.descriptionHouse.distribution.kitchen === true ? "X" : "",
            "W65": visit.descriptionHouse.distribution.backyard === true ? "X" : "",
            "X66": visit.descriptionHouse.distribution.bathroom || "",
            "X67": visit.descriptionHouse.distribution.bedroom || "",
            "X68": visit.descriptionHouse.distribution.people || "",

            //public services
            "AF62": visit.descriptionHouse.publicServices.telephone === true ? "X" : "",
            "AF63": visit.descriptionHouse.publicServices.electricity === true ? "X" : "",
            "AF64": visit.descriptionHouse.publicServices.water === true ? "X" : "",
            "AF65": visit.descriptionHouse.publicServices.sewerage === true ? "X" : "",
            "AF66": visit.descriptionHouse.publicServices.gas === true ? "X" : "",
            "AF67": visit.descriptionHouse.publicServices.internet === true ? "X" : "",
            "AF68": visit.descriptionHouse.publicServices.other || "",

            //property
            "H70": visit.descriptionHouse.property || "N/A",
            "AB70": visit.descriptionHouse.propertyPhone || "N/A",
            "M71": visit.descriptionHouse.timeToLive || "N/A",
            "AC71": visit.descriptionHouse.wannaContinue === "SI" ? "X" : "",
            "AF71": visit.descriptionHouse.wannaContinue === "NO" ? "X" : "",
            "O72": visit.descriptionHouse.inNegative || "N/A",
            "X73": visit.descriptionHouse.lastHouse || "N/A",

            //furniture
            "E77": visit.descriptionHouse.furniture.livingRoomFurniture === true ? "X" : "",
            "E78": visit.descriptionHouse.furniture.bedFurniture === true ? "X" : "",
            "L77": visit.descriptionHouse.furniture.diningRoomFurniture === true ? "X" : "",
            "L78": visit.descriptionHouse.furniture.howManyBeds || "N/A",

            //household appliances
            "R77": visit.descriptionHouse.householdAppliances.fridge === true ? "X" : "",
            "R78": visit.descriptionHouse.householdAppliances.washingMachine === true ? "X" : "",
            "X77": visit.descriptionHouse.householdAppliances.computer === true ? "X" : "",
            "X78": visit.descriptionHouse.householdAppliances.soundSystem === true ? "X" : "",
            "AC77": visit.descriptionHouse.householdAppliances.tv === true ? "X" : "",
            "AC78": visit.descriptionHouse.householdAppliances.dryer === true ? "X" : "",
            "AG77": visit.descriptionHouse.householdAppliances.howManyTv || "N/A",

            // residential zone
            [getCellPositionZone(visit.descriptionHouse.zone)]: "X",

            //sector description
            "R83": visit.descriptionHouse.sectorDescription.church === true ? "X" : "",
            "R84": visit.descriptionHouse.sectorDescription.school === true ? "X" : "",
            "R85": visit.descriptionHouse.sectorDescription.college === true ? "X" : "",
            "Z83": visit.descriptionHouse.sectorDescription.funnyCenter === true ? "X" : "",
            "Z84": visit.descriptionHouse.sectorDescription.healthCenter === true ? "X" : "",
            "Z85": visit.descriptionHouse.sectorDescription.health === true ? "X" : "",
            "AF83": visit.descriptionHouse.sectorDescription.busStations === true ? "X" : "",
            "AF84": visit.descriptionHouse.sectorDescription.supermarket === true ? "X" : "",
            "AF85": visit.descriptionHouse.sectorDescription.vigilance === true ? "X" : "",

            // economic activity
            "P88": visit.economicInfo.howManyPeople || "N/A",
            "W88": visit.economicInfo.kinship || "N/A",

            // incomes table

            // expenses
            "X93": parseFloat(visit.economicInfo.expenses.food) || "0",
            "X94": parseFloat(visit.economicInfo.expenses.transport) || "0",
            "X95": parseFloat(visit.economicInfo.expenses.recreational) || "0",
            "X96": parseFloat(visit.economicInfo.expenses.education) || "0",
            "X97": parseFloat(visit.economicInfo.expenses.rent) || "0",
            "X98": parseFloat(visit.economicInfo.expenses.vehicleFee) || "0",
            "X99": parseFloat(visit.economicInfo.expenses.houseFee) || "0",
            "AG93": parseFloat(visit.economicInfo.expenses.phone) || "0",
            "AG94": parseFloat(visit.economicInfo.expenses.electricity) || "0",
            "AG95": parseFloat(visit.economicInfo.expenses.water) || "0",
            "AG96": parseFloat(visit.economicInfo.expenses.sewerage) || "0",
            "AG97": parseFloat(visit.economicInfo.expenses.gas) || "0",
            "AG98": parseFloat(visit.economicInfo.expenses.internet) || "0",
            "AG99": parseFloat(visit.economicInfo.expenses.other) || "0",
            "AD100": (
                parseFloat(visit.economicInfo.expenses.food || 0) +
                parseFloat(visit.economicInfo.expenses.transport || 0) +
                parseFloat(visit.economicInfo.expenses.recreational || 0) +
                parseFloat(visit.economicInfo.expenses.education || 0) +
                parseFloat(visit.economicInfo.expenses.rent || 0) +
                parseFloat(visit.economicInfo.expenses.vehicleFee || 0) +
                parseFloat(visit.economicInfo.expenses.houseFee || 0) +
                parseFloat(visit.economicInfo.expenses.phone || 0) +
                parseFloat(visit.economicInfo.expenses.electricity || 0) +
                parseFloat(visit.economicInfo.expenses.water || 0) +
                parseFloat(visit.economicInfo.expenses.sewerage || 0) +
                parseFloat(visit.economicInfo.expenses.gas || 0) +
                parseFloat(visit.economicInfo.expenses.internet || 0) +
                parseFloat(visit.economicInfo.expenses.other || 0)
            ),

            //alliance
            "I134": visit.concept.alliance.organizedCrime === true ? "SI" : "NO",
            "I135": visit.concept.alliance.gangs === true ? "SI" : "NO",
            "I136": visit.concept.alliance.muggers === true ? "SI" : "NO",
            "I137": visit.concept.alliance.outlawGroups === true ? "SI" : "NO",
            "I138": visit.concept.alliance.illegalCasinos === true ? "SI" : "NO",
            "R134": visit.concept.alliance.drugAddicts === true ? "SI" : "NO",
            "R135": visit.concept.alliance.drugTraffickers === true ? "SI" : "NO",
            "R136": visit.concept.alliance.drugDealers === true ? "SI" : "NO",
            "R137": visit.concept.alliance.carjackers === true ? "SI" : "NO",
            "R138": visit.concept.alliance.murders === true ? "SI" : "NO",
            "Z134": visit.concept.alliance.apartmentBurglars === true ? "SI" : "NO",
            "Z135": visit.concept.alliance.scammers === true ? "SI" : "NO",
            "Z136": visit.concept.alliance.landPiracy === true ? "SI" : "NO",
            "Z137": visit.concept.alliance.kidnappers === true ? "SI" : "NO",
            "Z138": visit.concept.alliance.domesticViolence === true ? "SI" : "NO",
            "AG134": visit.concept.alliance.smugglers === true ? "SI" : "NO",
            "AG135": visit.concept.alliance.moneyLaunderers === true ? "SI" : "NO",
            "AG136": visit.concept.alliance.extortionists === true ? "SI" : "NO",
            "AG137": visit.concept.alliance.brothels === true ? "SI" : "NO",
            "AG138": visit.concept.alliance.otherCriminalActs === true ? "SI" : "NO",

            //observations
            "B140": "Observaciones: " + visit.concept.observations || "N/A",
            "B142": "Concepto: " + text || "N/A",
            "O164": visit.concept.academicEvidence === "SI" ? "X" : "",
            "Q164": visit.concept.academicEvidence === "NO" ? "X" : "",
            "AC164": visit.concept.employmentEvidence === "SI" ? "X" : "",
            "AE164": visit.concept.employmentEvidence === "NO" ? "X" : "",
            "Q166": visit.concept.concept === "Favorable" ? "X" : "",
            "AB166": visit.concept.concept === "Se deja a consideración del empleador" ? "X" : "",

            "H167": visit.visitorName || "N/A",
        };

        // Fill the cells using the mapping
        Object.entries(cellDataMapping).forEach(([cell, value]) => {
            worksheet.getCell(cell).value = value;
        });

        if (cellPath === "AA14") {
            worksheet.getCell("AC14").value = visit.basicData.educationLevel || "N/A";
        }

        // Add family information to the Excel sheet
        // Table 2.1
        if (visit.familyInfo && Array.isArray(visit.familyInfo.originFamily)) {
            visit.familyInfo.originFamily.forEach((familyMember, index) => {
                const rowIndex = 21 + index; // Start at row 21 and increment for each family member
                worksheet.getCell(`A${rowIndex}`).value = familyMember.name || "N/A";
                worksheet.getCell(`L${rowIndex}`).value = familyMember.age || "N/A";
                worksheet.getCell(`M${rowIndex}`).value = getIdTypeDocument(familyMember.typeDocument) || "N/A";
                worksheet.getCell(`N${rowIndex}`).value = familyMember.numberDocument || "N/A";
                worksheet.getCell(`Q${rowIndex}`).value = familyMember.kinship || "N/A";
                worksheet.getCell(`T${rowIndex}`).value = familyMember.phone || "N/A";
                worksheet.getCell(`W${rowIndex}`).value = familyMember.occupation || "N/A";
                worksheet.getCell(`AA${rowIndex}`).value = familyMember.city || "N/A";
                worksheet.getCell(`AC${rowIndex}`).value = familyMember.companyOrInstitution || "N/A";
                if (familyMember.livesApplicant === "SI") {
                    worksheet.getCell(`AG${rowIndex}`).value = "X" || "N/A";
                }
                else if (familyMember.livesApplicant === "NO") {
                    worksheet.getCell(`AH${rowIndex}`).value = "X" || "N/A";
                }
                rowFinal = rowIndex; // Update the rowFinal variable to the last filled row
            });
            if (rowFinal <= 30) {
                worksheet.getCell(`A${rowFinal + 1}`).value = "N/A";
                worksheet.getCell(`L${rowFinal + 1}`).value = "N/A";
                worksheet.getCell(`M${rowFinal + 1}`).value = "N/A";
                worksheet.getCell(`N${rowFinal + 1}`).value = "N/A";
                worksheet.getCell(`Q${rowFinal + 1}`).value = "N/A";
                worksheet.getCell(`T${rowFinal + 1}`).value = "N/A";
                worksheet.getCell(`W${rowFinal + 1}`).value = "N/A";
                worksheet.getCell(`AA${rowFinal + 1}`).value = "N/A";
                worksheet.getCell(`AC${rowFinal + 1}`).value = "N/A";
            }
        } else {
            rowFinal = 21
            worksheet.getCell(`A${rowFinal}`).value = "N/A";
            worksheet.getCell(`L${rowFinal}`).value = "N/A";
            worksheet.getCell(`M${rowFinal}`).value = "N/A";
            worksheet.getCell(`N${rowFinal}`).value = "N/A";
            worksheet.getCell(`Q${rowFinal}`).value = "N/A";
            worksheet.getCell(`T${rowFinal}`).value = "N/A";
            worksheet.getCell(`W${rowFinal}`).value = "N/A";
            worksheet.getCell(`AA${rowFinal}`).value = "N/A";
            worksheet.getCell(`AC${rowFinal}`).value = "N/A";
        }

        // Table 2.2
        if (visit.familyInfo && Array.isArray(visit.familyInfo.nucleusFamily)) {
            visit.familyInfo.nucleusFamily.forEach((familyMember, index) => {
                const rowIndex = 38 + index; // Start at row 38 and increment for each family member
                worksheet.getCell(`A${rowIndex}`).value = familyMember.name || "N/A";
                worksheet.getCell(`L${rowIndex}`).value = familyMember.age || "N/A";
                worksheet.getCell(`M${rowIndex}`).value = getIdTypeDocument(familyMember.typeDocument) || "N/A";
                worksheet.getCell(`N${rowIndex}`).value = familyMember.numberDocument || "N/A";
                worksheet.getCell(`Q${rowIndex}`).value = familyMember.kinship || "N/A";
                worksheet.getCell(`T${rowIndex}`).value = familyMember.phone || "N/A";
                worksheet.getCell(`W${rowIndex}`).value = familyMember.occupation || "N/A";
                worksheet.getCell(`AA${rowIndex}`).value = familyMember.city || "N/A";
                worksheet.getCell(`AC${rowIndex}`).value = familyMember.companyOrInstitution || "N/A";
                if (familyMember.livesApplicant === "SI") {
                    worksheet.getCell(`AG${rowIndex}`).value = "X" || "N/A";
                }
                else if (familyMember.livesApplicant === "NO") {
                    worksheet.getCell(`AH${rowIndex}`).value = "X" || "N/A";
                }
                rowFinal = rowIndex; // Update the rowFinal variable to the last filled row
            });
            if (rowFinal <= 44) {
                worksheet.getCell(`A${rowFinal + 1}`).value = "N/A";
                worksheet.getCell(`L${rowFinal + 1}`).value = "N/A";
                worksheet.getCell(`M${rowFinal + 1}`).value = "N/A";
                worksheet.getCell(`N${rowFinal + 1}`).value = "N/A";
                worksheet.getCell(`Q${rowFinal + 1}`).value = "N/A";
                worksheet.getCell(`T${rowFinal + 1}`).value = "N/A";
                worksheet.getCell(`W${rowFinal + 1}`).value = "N/A";
                worksheet.getCell(`AA${rowFinal + 1}`).value = "N/A";
                worksheet.getCell(`AC${rowFinal + 1}`).value = "N/A";
            }
        } else {
            rowFinal = 38
            worksheet.getCell(`A${rowFinal}`).value = "N/A";
            worksheet.getCell(`L${rowFinal}`).value = "N/A";
            worksheet.getCell(`M${rowFinal}`).value = "N/A";
            worksheet.getCell(`N${rowFinal}`).value = "N/A";
            worksheet.getCell(`Q${rowFinal}`).value = "N/A";
            worksheet.getCell(`T${rowFinal}`).value = "N/A";
            worksheet.getCell(`W${rowFinal}`).value = "N/A";
            worksheet.getCell(`AA${rowFinal}`).value = "N/A";
            worksheet.getCell(`AC${rowFinal}`).value = "N/A";
        }

        // Table 2.3
        if (visit.familyInfo && Array.isArray(visit.familyInfo.otherFamily)) {
            visit.familyInfo.otherFamily.forEach((familyMember, index) => {
                const rowIndex = 49 + index; // Start at row 49 and increment for each family member
                worksheet.getCell(`A${rowIndex}`).value = familyMember.name || "N/A";
                worksheet.getCell(`L${rowIndex}`).value = familyMember.age || "N/A";
                worksheet.getCell(`M${rowIndex}`).value = getIdTypeDocument(familyMember.typeDocument) || "N/A";
                worksheet.getCell(`N${rowIndex}`).value = familyMember.numberDocument || "N/A";
                worksheet.getCell(`Q${rowIndex}`).value = familyMember.kinship || "N/A";
                worksheet.getCell(`T${rowIndex}`).value = familyMember.phone || "N/A";
                worksheet.getCell(`W${rowIndex}`).value = familyMember.occupation || "N/A";
                worksheet.getCell(`AA${rowIndex}`).value = familyMember.city || "N/A";
                worksheet.getCell(`AC${rowIndex}`).value = familyMember.companyOrInstitution || "N/A";
                if (familyMember.livesApplicant === "SI") {
                    worksheet.getCell(`AG${rowIndex}`).value = "X" || "N/A";
                }
                else if (familyMember.livesApplicant === "NO") {
                    worksheet.getCell(`AH${rowIndex}`).value = "X" || "N/A";
                }
                rowFinal = rowIndex; // Update the rowFinal variable to the last filled row
            });
            if (rowFinal <= 55) {
                worksheet.getCell(`A${rowFinal + 1}`).value = "N/A";
                worksheet.getCell(`L${rowFinal + 1}`).value = "N/A";
                worksheet.getCell(`M${rowFinal + 1}`).value = "N/A";
                worksheet.getCell(`N${rowFinal + 1}`).value = "N/A";
                worksheet.getCell(`Q${rowFinal + 1}`).value = "N/A";
                worksheet.getCell(`T${rowFinal + 1}`).value = "N/A";
                worksheet.getCell(`W${rowFinal + 1}`).value = "N/A";
                worksheet.getCell(`AA${rowFinal + 1}`).value = "N/A";
                worksheet.getCell(`AC${rowFinal + 1}`).value = "N/A";
            }
        } else {
            rowFinal = 49
            worksheet.getCell(`A${rowFinal}`).value = "N/A";
            worksheet.getCell(`L${rowFinal}`).value = "N/A";
            worksheet.getCell(`M${rowFinal}`).value = "N/A";
            worksheet.getCell(`N${rowFinal}`).value = "N/A";
            worksheet.getCell(`Q${rowFinal}`).value = "N/A";
            worksheet.getCell(`T${rowFinal}`).value = "N/A";
            worksheet.getCell(`W${rowFinal}`).value = "N/A";
            worksheet.getCell(`AA${rowFinal}`).value = "N/A";
            worksheet.getCell(`AC${rowFinal}`).value = "N/A";
        }

        // Add economic information to the Excel sheet
        // Table Incomes
        let totalHomeIncome = 0; // Initialize a variable to store the sum of home incomes
        let totalFees = 0; // Initialize a variable to store the sum of fees
        if (visit.economicInfo && Array.isArray(visit.economicInfo.incomes)) {
            visit.economicInfo.incomes.forEach((familyMember, index) => {
                const rowIndex = 93 + index; // Start at row 93 and increment for each family member
                worksheet.getCell(`A${rowIndex}`).value = familyMember.nameIncome || "N/A";
                worksheet.getCell(`L${rowIndex}`).value = parseFloat(familyMember.totalIncome) || "N/A";
                worksheet.getCell(`O${rowIndex}`).value = parseFloat(familyMember.homeIncome) || "N/A";

                // Convert homeIncome to a number and add it to the total
                const homeIncomeValue = parseFloat(familyMember.homeIncome) || 0;
                totalHomeIncome += homeIncomeValue;
                rowFinal = rowIndex; // Update the rowFinal variable to the last filled row
            });
            if (rowFinal <= 99) {
                worksheet.getCell(`A${rowFinal + 1}`).value = "N/A";
                worksheet.getCell(`L${rowFinal + 1}`).value = "N/A";
                worksheet.getCell(`O${rowFinal + 1}`).value = "N/A";
            }
        } else {
            rowFinal = 93
            worksheet.getCell(`A${rowFinal}`).value = "N/A";
            worksheet.getCell(`L${rowFinal}`).value = "N/A";
            worksheet.getCell(`O${rowFinal}`).value = "N/A";
        }
        // Set the total home income in cell W100
        worksheet.getCell("O100").value = totalHomeIncome;

        // Table Credits
        totalHomeIncome = 0; // Initialize a variable to store the sum of home incomes
        totalFees = 0;
        if (visit.economicInfo && Array.isArray(visit.economicInfo.credits)) {
            visit.economicInfo.credits.forEach((familyMember, index) => {
                const rowIndex = 103 + index; // Start at row 103 and increment for each family member
                worksheet.getCell(`A${rowIndex}`).value = familyMember.motive || "N/A";
                worksheet.getCell(`H${rowIndex}`).value = familyMember.entity || "N/A";
                worksheet.getCell(`L${rowIndex}`).value = parseFloat(familyMember.amount) || "N/A";
                worksheet.getCell(`O${rowIndex}`).value = parseFloat(familyMember.fee) || "N/A";

                totalFees += parseFloat(familyMember.fee);
                totalHomeIncome += parseFloat(familyMember.amount); // Add the amount to the total home income
                rowFinal = rowIndex; // Update the rowFinal variable to the last filled row
            });
            if (rowFinal <= 105) {
                worksheet.getCell(`A${rowFinal + 1}`).value = "N/A";
                worksheet.getCell(`H${rowFinal + 1}`).value = "N/A";
                worksheet.getCell(`L${rowFinal + 1}`).value = "N/A";
                worksheet.getCell(`O${rowFinal + 1}`).value = "N/A";
            }

        } else {
            rowFinal = 103
            worksheet.getCell(`A${rowFinal}`).value = "N/A";
            worksheet.getCell(`H${rowFinal}`).value = "N/A";
            worksheet.getCell(`L${rowFinal}`).value = "N/A";
            worksheet.getCell(`O${rowFinal}`).value = "N/A";
        }
        worksheet.getCell("L106").value = totalHomeIncome;
        worksheet.getCell("O106").value = totalFees;

        // Table Savings
        totalHomeIncome = 0; // Initialize a variable to store the sum of home incomes
        if (visit.economicInfo && Array.isArray(visit.economicInfo.savings)) {
            visit.economicInfo.savings.forEach((familyMember, index) => {
                const rowIndex = 103 + index; // Start at row 103 and increment for each family member
                worksheet.getCell(`S${rowIndex}`).value = familyMember.entity || "N/A";
                worksheet.getCell(`Z${rowIndex}`).value = familyMember.date || "N/A";
                worksheet.getCell(`AE${rowIndex}`).value = parseFloat(familyMember.amount) || "N/A";

                totalHomeIncome += parseFloat(familyMember.amount) || 0; // Add the amount to the total home income
                rowFinal = rowIndex; // Update the rowFinal variable to the last filled row
            });
            if (rowFinal <= 105) {
                worksheet.getCell(`S${rowFinal + 1}`).value = "N/A";
                worksheet.getCell(`Z${rowFinal + 1}`).value = "N/A";
                worksheet.getCell(`AE${rowFinal + 1}`).value = "N/A";
            }

        } else {
            rowFinal = 103
            worksheet.getCell(`S${rowFinal}`).value = "N/A";
            worksheet.getCell(`Z${rowFinal}`).value = "N/A";
            worksheet.getCell(`AE${rowFinal}`).value = "N/A";
        }
        worksheet.getCell("AE106").value = totalHomeIncome;

        // Table Properties
        totalHomeIncome = 0;
        if (visit.economicInfo && Array.isArray(visit.economicInfo.properties)) {
            visit.economicInfo.properties.forEach((familyMember, index) => {
                const rowIndex = 109 + index; // Start at row 109 and increment for each family member
                worksheet.getCell(`A${rowIndex}`).value = familyMember.type || "N/A";
                worksheet.getCell(`G${rowIndex}`).value = familyMember.address || "N/A";
                worksheet.getCell(`O${rowIndex}`).value = parseFloat(familyMember.value) || "N/A";

                totalHomeIncome += parseFloat(familyMember.value) || 0; // Add the amount to the total home income
                rowFinal = rowIndex; // Update the rowFinal variable to the last filled row
            });
            if (rowFinal <= 113) {
                worksheet.getCell(`A${rowFinal + 1}`).value = "N/A";
                worksheet.getCell(`G${rowFinal + 1}`).value = "N/A";
                worksheet.getCell(`O${rowFinal + 1}`).value = "N/A";
            }

        } else {
            rowFinal = 109
            worksheet.getCell(`A${rowFinal}`).value = "N/A";
            worksheet.getCell(`G${rowFinal}`).value = "N/A";
            worksheet.getCell(`O${rowFinal}`).value = "N/A";
        }
        worksheet.getCell("O114").value = totalHomeIncome;

        // Table Vehicles
        totalHomeIncome = 0;
        if (visit.economicInfo && Array.isArray(visit.economicInfo.vehicles)) {
            visit.economicInfo.vehicles.forEach((familyMember, index) => {
                const rowIndex = 109 + index; // Start at row 109 and increment for each family member
                worksheet.getCell(`S${rowIndex}`).value = familyMember.type || "N/A";
                worksheet.getCell(`W${rowIndex}`).value = familyMember.brand || "N/A";
                worksheet.getCell(`AA${rowIndex}`).value = familyMember.model || "N/A";
                worksheet.getCell(`AD${rowIndex}`).value = familyMember.plate || "N/A";
                worksheet.getCell(`AF${rowIndex}`).value = parseFloat(familyMember.value) || "N/A";

                totalHomeIncome += parseFloat(familyMember.value) || 0; // Add the amount to the total home income
                rowFinal = rowIndex; // Update the rowFinal variable to the last filled row
            });
            if (rowFinal <= 113) {
                worksheet.getCell(`S${rowFinal + 1}`).value = "N/A";
                worksheet.getCell(`W${rowFinal + 1}`).value = "N/A";
                worksheet.getCell(`AA${rowFinal + 1}`).value = "N/A";
                worksheet.getCell(`AD${rowFinal + 1}`).value = "N/A";
                worksheet.getCell(`AF${rowFinal + 1}`).value = "N/A";
            }
        } else {
            rowFinal = 109
            worksheet.getCell(`S${rowFinal}`).value = "N/A";
            worksheet.getCell(`W${rowFinal}`).value = "N/A";
            worksheet.getCell(`AA${rowFinal}`).value = "N/A";
            worksheet.getCell(`AD${rowFinal}`).value = "N/A";
            worksheet.getCell(`AF${rowFinal}`).value = "N/A";
        }
        worksheet.getCell("AF114").value = totalHomeIncome;


        // Load the image of plate
        const imageResponse = await fetch(visit.pictures.urlFrontHouse);
        const imageBuffer = await imageResponse.arrayBuffer();

        // Load the image front of house
        const imageResponseFront = await fetch(visit.pictures.urlAddressPlate);
        const imageBufferFront = await imageResponseFront.arrayBuffer();

        // Load the image of candidate
        const imageResponseCandidate = await fetch(visit.pictures.urlCandidate);
        const imageBufferCandidate = await imageResponseCandidate.arrayBuffer();

        // Fetch the image from Firebase Storage and load image of visitor signature
        const signatureRef = storageRef(storage, "visitorSignatures/" + visit.visitorId + "/signature.png");
        const signatureUrl = await getDownloadURL(signatureRef);
        const signatureResponse = await fetch(signatureUrl);
        const signatureBuffer = await signatureResponse.arrayBuffer();

        // Load the image of company logo
        const logoResponse = await fetch(urlPicture);
        const logoBuffer = await logoResponse.arrayBuffer();

        // Add the company logo image to the workbook
        const logoImageId = workbook.addImage({
            buffer: logoBuffer,
            extension: "png",
        });

        // Add the signature image to the workbook
        const signatureImageId = workbook.addImage({
            buffer: signatureBuffer,
            extension: "png",
        });

        // Add the image to the workbook
        const imageId = workbook.addImage({
            buffer: imageBuffer,
            extension: "jpg",
        });

        // Add the image to the workbook
        const imageIdFront = workbook.addImage({
            buffer: imageBufferFront,
            extension: "jpg",
        });

        // Add the image to the workbook
        const imageIdCandidate = workbook.addImage({
            buffer: imageBufferCandidate,
            extension: "jpg",
        });

        // Position the company logo image in the workbook
        worksheet.addImage(logoImageId, {
            tl: { col: 7, row: 1 }, // Adjust the position as needed
            ext: { width: 150, height: 75 }, // Adjust the size as needed
        });

        // Position the image in the middle of the cell
        worksheet.addImage(imageId, {
            tl: { col: 2, row: 119.5 }, // Adjusted to center the image in the cell
            ext: { width: 300, height: 300 }, // Width and height of the image
        });

        // Position the image in the middle of the cell
        worksheet.addImage(imageIdFront, {
            tl: { col: 13.9, row: 119.5 }, // Adjusted to center the image in the cell
            ext: { width: 300, height: 300 }, // Width and height of the image
        });

        // Position the image in the middle of the cell
        worksheet.addImage(imageIdCandidate, {
            tl: { col: 24, row: 119.5 }, // Adjusted to center the image in the cell
            ext: { width: 300, height: 300 }, // Width and height of the image
        });


        // Position the signature image in cell V167
        worksheet.addImage(signatureImageId, {
            tl: { col: 21, row: 166.1 }, // Adjusted to position the image in cell V167
            ext: { width: 300, height: 75 }, // Width and height of the image
        });


        if (visit.companyName === "Fortox") {
            worksheet.getCell(`B169`).value = "FORMA: SPA-F2-14";
            worksheet.getCell(`H169`).value = "Visto Buento Foxtox:(Cuando lo ejecuta un externo)";
        }

        // Save the workbook to a file
        if (step === "excel") {
            const buffer = await workbook.xlsx.writeBuffer();
            const blob = new Blob([buffer], {
                type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
            });
            const link = document.createElement("a");
            link.href = URL.createObjectURL(blob);
            link.download = (visit.basicData.name + " " + visit.dateInit + ".xlsx").replace(/[/\\?%*:|"<>]/g, '-');
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
        } else {
            exportWorkbookAndConvert(workbook, dispatch, visit.basicData.name + " " + visit.dateInit); // Call the function to export and convert the workbook
        }




    } catch (error) {
        console.error("Error al procesar el archivo Excel:", error);
    }
};